<template>
  <div class="filter-setting" :style="{height: collapse ? '46px': '366px'}">
    <div class="filter-hearder" @click="collapse = !collapse">
      <span>滤镜</span>
      <i class="icon icon-set-down" :style="{transform: collapse ? '' : 'rotate(180deg)'}"></i>
    </div>

    <div class="filter-content">
      <SliderSetting :list="filterArr" @changeData="filterChange" />
    </div>
  </div>
</template>

<script>
import SliderSetting from './sliderSetting.vue'

export default {
  props: {
    filters: {
      type: Object,
      required: true,
      default: function() {
        return {
          blur: 0,
          brightness: 1,
          contrast: 1,
          saturate: 1,
          grayscale: 0,
          hueRotate: 0,
          invert: 0,
          sepia: 0
        }
      }
    }
  },
  data () {
    return {
      collapse: false,
      filterArr: [
        {type: 'blur', name: '模糊', step: 1, min: 0, max: 100, len:100, val: 0},
        {type: 'brightness', name: '亮度', step: 1, min: 0, max: 10, len:10, val: 1},
        {type: 'contrast', name: '对比度', step: 1, min: 0, max: 10, len:10, val: 1},
        {type: 'saturate', name: '饱和度', step: 1, min: 0, max: 10, len:10, val: 1},
        {type: 'grayscale', name: '灰度', step: 0.1, min: 0, max: 1, len:1, val: 0},
        {type: 'hueRotate', name: '色相', step: 1, min: 0, max: 360, len:360, val: 0},
        {type: 'invert', name: '反色', step: 0.1, min: 0, max: 1, len:1, val: 0},
        {type: 'sepia', name: '加温', step: 0.1, min: 0, max: 1, len:1, val: 0}
      ]
    }
  },
  watch: {
    filters() {
      this.syncData()
    }
  },
  mounted() {
    // watch在filter初次加载之后导致数据刷不到
    this.syncData();
  },
  methods: {
    syncData(bol) {
      this.filterArr.forEach((v, i, arr) => {
        if(!bol) {
          arr[i].val = this.filters[v.type];
        } else {
          this.filters[v.type] = v.val
        }
      })
    },
    filterChange(val, status, index, item) {
      this.filters[item.type] = val;
      this.$emit('changeData', val, status, item.type, this.filters);
    }
  },
  components: {
    SliderSetting
  }
}
</script>

<style lang="scss" scoped>
.filter-setting {
  width: 100%;
  transition: all 0.3s;
  border-bottom: 1px solid #D4D4E7;
  overflow: hidden;
}
.filter-hearder {
  display: flex;
  height: 46px;
  line-height: 46px;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: #474261;
  cursor: pointer;

  i {
    width: 10px;
    height: 6px;
    margin-right: 10px;
    transition: all 0.3s;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/settingPanel/filterSetting.vue